import { INotificationTemplateDto } from "@kuika/kuika-cl-model";

export const SET_SHOW_MODAL = "SET_SHOW_MODAL";
export const SET_UNSAVED_CHANGES = "SET_UNSAVED_CHANGES";
export const SET_NEXT_CALLBACK_FUNCTION = "SET_NEXT_CALLBACK_FUNCTION";

export interface UnsavedChangesModalModuleState {
  showModal: boolean;
  nextTemplate: INotificationTemplateDto | null;
  hasUnsavedChanges: boolean;
  nextCallback?: () => void;
}

export interface SetShowModalAction {
  type: typeof SET_SHOW_MODAL;
  meta: {
    params: {
      showModal: UnsavedChangesModalModuleState["showModal"];
      nextTemplate: UnsavedChangesModalModuleState["nextTemplate"];
    };
  };
}

export interface SetUnsavedChangesAction {
  type: typeof SET_UNSAVED_CHANGES;
  meta: {
    params: {
      hasUnsavedChanges: UnsavedChangesModalModuleState["hasUnsavedChanges"];
    };
  };
}

export interface SetNextCallbackFunction {
  type: typeof SET_NEXT_CALLBACK_FUNCTION;
  meta: {
    params: {
      nextCallback: UnsavedChangesModalModuleState["nextCallback"];
    };
  };
}

export type UnsavedChangesModalModuleActionTypes =
  | SetUnsavedChangesAction
  | SetShowModalAction
  | SetNextCallbackFunction;
